module.exports = __webpack_public_path__ + "components/rewards/treads-and-trails/static/icon-32631d8a7910879399e3a20e6318292c.png";